import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectTeamServiceService {

  constructor(private api: ApiwrapperService) { }

  getProjectTeamStatistics(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamStatistics(projectUuid);
  }

  getProjectTeamChartData(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamChartData(projectUuid);
  }

  getProjectTeamTimedQuestionCollections(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamTimedQuestionCollections(projectUuid);
  }

  getProjectTeamTimedQuestionCollectionScore(collectionUuid: string, collectionBody: any): Observable<any> {
    return this.api.projectTeamTimedQuestionCollectionScore(collectionUuid, collectionBody);
  }

  getIndicatorInterval(): Observable<any> {
    return this.api.getIndicatorInterval();
  }

  getProjectTeamLeaders(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamLeaders(projectUuid);
  }

  getProjectTeamMembers(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamMembers(projectUuid);
  }

  getProjectTeamHighlights(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamHighlights(projectUuid);
  }

  getProjectTeamAssignments(projectUuid: string): Observable<any> {
      return this.api.getProjectTeamAssignments(projectUuid);
  }

  getCollectionQuestions(questionUuid: string): Observable<any> {
    return this.api.getProjectTeamCollectionQuestions(questionUuid);
  }

  getCollectionQuestionScore(questionUuid: string, projectUuid: string): Observable<any> {
    return this.api.getProjectTeamCollectionQuestionScore(questionUuid, projectUuid);
  }

  getCollectionQuestionResponses(questionUuid: string, projectUuid: string, questionType: string, page: any, limit: any): Observable<any> {
    return this.api.getProjectTeamCollectionQuestionResponses(questionUuid, projectUuid, questionType, page, limit);
  }

  getActiveProjectDetails(projectUuid: string): Observable<any> {
    return this.api.getActiveProjectDetails(projectUuid);
  }

  patchProjectDeadline(projectUuid: string, changedDate: any): Observable<any> {
    return this.api.patchProjectTeam(projectUuid, changedDate);
  }

  patchProjectStatus(projectUuid: string, changedStatus: any): Observable<any> {
    return this.api.patchProjectTeam(projectUuid, changedStatus);
  }

  searchUser(searchValue: string): Observable<any> {
    return this.api.getSearchWorkspaceMember(searchValue);
  }

  addMembersToProjectTeam(membersBody: any): Observable<any> {
    return this.api.addProjectTeamMembers(membersBody);
  }

  deleteMemberFromProject(projectUuid: string, projectMemberUuid: string) {
    return this.api.deleteProjectMember(projectUuid, projectMemberUuid);
  }
}
